import type { IIntegrationFormData } from "src/integrations/forms/IIntegrationFormData";
import {
  type IIntegrationFormDataShopify,
  integrationDataToIntegrationShopify,
  integrationToIntegrationDataShopify,
} from "src/integrations/forms/shopify/IIntegrationFormDataShopify";
import type { IntegrationShopify } from "src/integrations/objects/IntegrationShopify";
import type { IntegrationType } from "src/integrations/objects/IntegrationType";

export const INTEGRATION_SHOPIFY_IS_POST_CHECKOUT_SUBSCRIBE =
  "isPostCheckoutSubscribe";

export interface IIntegrationFormDataShopifyCustomer
  extends IIntegrationFormDataShopify {
  [INTEGRATION_SHOPIFY_IS_POST_CHECKOUT_SUBSCRIBE]: boolean;
}

export function integrationDataToIntegrationShopifyCustomer(
  integrationType: IntegrationType,
  integrationData: Partial<IIntegrationFormData>,
  integrationUuid?: string,
): Partial<IntegrationShopify> {
  return integrationDataToIntegrationShopify(
    integrationType,
    integrationData,
    integrationUuid,
  );
}

export function integrationToIntegrationDataShopifyCustomer(
  integrationType: IntegrationType,
  integration: IntegrationShopify,
): Partial<IIntegrationFormDataShopifyCustomer> {
  return integrationToIntegrationDataShopify(integrationType, integration);
}
